import { UPDATE_DEALER_SUCCESS } from 'constants/ActionTypes';
import { PUT_SUCCESS as UPDATE_APPOINTMENT_SUCCESS } from 'modules/appointments/actionTypes';
import * as auditActions from 'modules/audits/actionTypes';
import * as checklistActionTypes from 'modules/checklists/actionTypes';

import { PUT_GUIDELINE_SUCCESS } from 'modules/guidelines/actionTypes';
import { UPDATE_INTERVENTION_SUCCESS } from 'modules/interventions/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../actionTypes';

const initialState = {};

const beforeUpload = (state, { meta = {} }) => {
  const { source } = meta;
  if (source) {
    return {
      ...state,
      [source]: {
        ...(state[source] ?? {}),
        isLoading: true,
        apiError: null,
        remainingMediaToUpload: (state[source]?.remainingMediaToUpload ?? 0) + 1,
      },
    };
  }
  return state;
};

const uploadedSuccess = (state, { payload: media, meta = {} }) => {
  const { source } = meta;
  if (source) {
    return {
      ...state,
      [source]: {
        ...(state[source] ?? {}),
        medias: [...(state?.[source]?.medias ?? []), media],
        isLoading: false,
        remainingMediaToUpload: state[source].remainingMediaToUpload - 1,
      },
    };
  }
  return state;
};

const uploadedFailure = (state, { payload: apiError, meta = {} }) => {
  const { source } = meta;
  if (source) {
    return {
      ...state,
      [source]: {
        ...(state[source] ?? {}),
        isLoading: false,
        apiError,
      },
    };
  }
  return state;
};

const clearUploadedMedias = (state, { payload }) => {
  const { [payload.source]: _toRemove, ...newState } = state;
  return newState;
};

const flushUploadedMedias = (state, { payload, meta }) => {
  const { mediaId } = payload;
  const source = payload.source ?? meta.source;
  if (state[source]?.medias?.length > 0) {
    return {
      ...state,
      [source]: {
        ...state[source],
        medias: state[source].medias.filter(({ id }) => id !== mediaId),
      },
    };
  }
  return state;
};

const clearAllUploadedMedias = () => initialState;

const persistSuccess = (state, { payload, meta }) => {
  const { source } = meta;
  if (source) {
    return {
      ...state,
      [source]: {
        ...(state[source] ?? {}),
        medias: state[source].medias.reduce((acc, media) => {
          const persistedMedia = payload.content.find(({ uploadId }) => uploadId === media.uploadId);
          acc.push({
            ...meta?.additionalData,
            ...media,
            ...(persistedMedia ?? {}),
          });
          return acc;
        }, []),
      },
    };
  }
  return state;
};

const patchMedia = (state, { payload, meta }) => {
  const { source } = meta;
  const mediaId = payload.request.data.id;
  if (source) {
    const medias = state[source]?.medias?.map((media) => (media.id === mediaId ? { ...media, loading: true } : media));
    return {
      ...state,
      [source]: {
        ...(state[source] ?? {}),
        medias,
      },
    };
  }
  return state;
};

const patchMediaSuccess = (state, { payload, meta }) => {
  const { source } = meta;
  if (source) {
    const medias = state[source]?.medias?.reduce((acc, media) => [...acc, media.id === payload.id ? { ...media, ...payload } : media], []);
    return {
      ...state,
      [source]: {
        ...(state[source] ?? {}),
        medias,
      },
    };
  }
  return state;
};

export default createReducer(initialState, {
  [actionTypes.UPLOAD_TWO_STEPS]: beforeUpload,
  [actionTypes.DELETE_MEDIA_SUCCESS]: flushUploadedMedias,
  [actionTypes.UPLOAD_TWO_STEPS_SUCCESS]: uploadedSuccess,
  [actionTypes.UPLOAD_TWO_STEPS_FAILURE]: uploadedFailure,
  [actionTypes.FLUSH_UPLOADED_MEDIAS]: flushUploadedMedias,
  [actionTypes.PERSIST_ITEMS_TO_ENTITY_SUCCESS]: persistSuccess,

  [actionTypes.PATCH_MEDIA]: patchMedia,
  [actionTypes.PATCH_MEDIA_SUCCESS]: patchMediaSuccess,

  // clear
  [LOCATION_CHANGE]: clearAllUploadedMedias,
  [UPDATE_DEALER_SUCCESS]: clearAllUploadedMedias,
  [PUT_GUIDELINE_SUCCESS]: clearAllUploadedMedias,
  [auditActions.PUT_SUCCESS]: clearAllUploadedMedias,
  [actionTypes.CLEAR_UPLOADED_MEDIAS]: clearUploadedMedias,
  [checklistActionTypes.UPDATE_SUCCESS]: clearAllUploadedMedias,
  [UPDATE_INTERVENTION_SUCCESS]: clearAllUploadedMedias,
  [UPDATE_APPOINTMENT_SUCCESS]: clearAllUploadedMedias,
});
